<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <h4 class="page-header">
                Security roles
              </h4>
              <hr />

              <div class="pb-3">
                <router-link
                  class="btn btn-primary"
                  :to="{ name: 'DivvyAdminManageCreateSecurityRoles' }"
                >
                  Create security role
                </router-link>
              </div>

              <div class="d-flex">
                <div class="col-6 form-group form-inline">
                  <span class="mr-1">Show </span>
                  <select
                    name="rolesTable_length"
                    class="form-control"
                    v-model="Pg_size"
                  >
                    <option :value="+10">10</option
                    ><option :value="+25">25</option
                    ><option :value="+50">50</option
                    ><option :value="+100">100</option>
                  </select>
                  <span class="ml-1"> entries</span>
                </div>

                <div class="form-group form-inline" style="margin-left: 275px;">
                  <span class="mr-1">Search:</span
                  ><input
                    type="search"
                    class="form-control input-sm"
                    v-model="SearchTerm"
                    aria-controls="rolesTable"
                  />
                </div>
              </div>

              <table class="table table-striped table-hover border rounded">
                <thead style="cursor: pointer;">
                  <tr>
                    <th style="width: 80%;">Name</th>
                    <th></th>
                  </tr>
                </thead>
                <tr v-if="Loading === true">
                  <td colspan="3">
                    <a-spin class="d-block" />
                  </td>
                </tr>
                <tbody v-else>
                  <tr v-for="role in getSecurityRolesData" :key="role.sec_id">
                    <td>
                      {{ role.label }}
                    </td>
                    <td>
                      <router-link
                        class="btn btn-primary"
                        :to="{
                          name: 'DivvyAdminManageEditSecurityRoles',
                          params: { id: role.sec_id },
                        }"
                      >
                        Edit
                      </router-link>
                      <router-link
                        class="btn btn-danger ml-2"
                        style="color: white;"
                        :to="{
                          name: 'DivvyAdminManageDeleteSecurityRoles',
                          params: { role: role.label, id: role.sec_id },
                        }"
                      >
                        Delete
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="mb-3" style="display: flex;">
                <div class="ml-1" style="flex-grow: 1;">
                  <div>
                    Showing {{ (Pg_num - 1) * Pg_size + 1 }} to
                    {{
                      TotalRecord < Pg_num * Pg_size
                        ? TotalRecord
                        : Pg_num * Pg_size
                    }}
                    of {{ TotalRecord }} entries
                  </div>
                </div>
                <div class="mr-1">
                  <Pagination
                    :data="getSecurityRolesData"
                    :totalPages="Math.ceil(TotalRecord / Pg_size)"
                    :total="TotalRecord"
                    :perPage="Pg_size"
                    :currentPage="Pg_num"
                    @pagechanged="onPageChange"
                  />
                </div>
              </div>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Pagination from "@/components/Pagination.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";

export default {
  name: "SecurityRoles",
  data() {
    return {
      Pg_num: 1,
      Pg_size: 10,
      SearchTerm: "",
      getSecurityRolesData: [],
      TotalRecord: null,
      Loading: false,
    };
  },
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
    Pagination,
  },
  watch: {
    SearchTerm(newVal, oldVal) {
      // console.log(newVal);
      this.Pg_num = 1;
      this.updateData();
    },
    Pg_size() {
      this.Pg_num = 1;
      this.updateData();
    },
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageRoles",
        activeMenu: this.activeMenu ? this.activeMenu : "security",
      });
    },
    updateData() {
      this.Loading = true;
      this.$store
        .dispatch("manageRoles/fetchSecurityRoles", {
          pg_num: this.Pg_num,
          pg_size: this.Pg_size,
          searchterm: this.SearchTerm,
        })
        .then((data) => {
          this.Loading = false;
          // console.log(data);
          this.getSecurityRolesData = data.result;
          this.TotalRecord = data.totalRecords;
        });
    },
    onPageChange(page) {
      console.log("page changed", page);
      this.Pg_num = page;
      try {
        this.updateData();
      } catch (error) {
        console.log(error);
      }
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.setActiveMenuItem();
    this.updateData();
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
